import {ECompanyNewsTab} from './definitions';

export default {
  tabs: {
    [ECompanyNewsTab.BLOG]: '[en] Блог',
    [ECompanyNewsTab.CASES]: '[en] Кейсы',
  },
};
